<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showAddPosition"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <div
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-1/2 w-full"
        >
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Add Position</p>
            <img
              v-if="!loading"
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <div class="grid grid-cols-3 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Position Title</label>
              <select class="p-2 bg-gray-200 rounded-full w-full">
                <option>Title</option>
              </select>
            </div>
            <div class="text-sm">
              <label class="block pb-1">Employment Type</label>
              <select class="p-2 bg-gray-200 rounded-full w-full">
                <option>Type</option>
              </select>
            </div>
            <div class="text-sm">
              <label class="block pb-1">Company</label>
              <select class="p-2 bg-gray-200 rounded-full w-full">
                <option>Location</option>
              </select>
            </div>
            <div class="text-sm">
              <label class="block pb-1">Department</label>
              <select class="p-2 bg-gray-200 rounded-full w-full">
                <option>Department</option>
              </select>
            </div>
            <div class="text-sm">
              <label class="block pb-1">Application Deadline</label>
              <input
                type="date"
                class="p-2 bg-gray-200 rounded-full w-full"
                placeholder="Deadline"
              />
            </div>
            <div class="text-sm">
              <label class="block pb-1">Share To</label>
              <div class="flex gap-10 pt-2 pl-2">
                <label class="b-contain">
                  <span>Linkedin</span>
                  <input v-model="selectedType" value="linkedin" type="radio" />
                  <div class="b-input"></div>
                </label>
                <label class="b-contain">
                  <span>Fuzu</span>
                  <input v-model="selectedType" type="radio" value="fuzu" />
                  <div class="b-input"></div>
                </label>
              </div>
            </div>
          </div>
          <div class="p-4">
            <label>Description</label>
            <textarea
              class="p-1 bg-gray-200 rounded-xl w-full"
              cols="5"
            ></textarea>
          </div>
          <div class="flex justify-end p-5">
            <button
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
      >
    </transition>
  </div>
</template>

<script>
export default {
  name: "AddPosition",
  props: ["showAddPosition"],
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
